import React from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import './TumisangSection.css';
import parse from "html-react-parser";

const InterviewBanner = ({ webpageData }) => {
  const interviewBannerData = webpageData?.interviewBannerData || {};
  const imgCDNURL = process.env.REACT_APP_CDN_LINK + "ussaic/";

  return (
    <div className="interview-banner">
      <div className="ramaswamy-bg">
      <div className="play-button-overlay-tm">
      <a
    href="https://youtu.be/n31XdEvhc1Y"
    target="_blank"
    rel="noopener noreferrer"
  >
  <img
    src={imgCDNURL + "play-button-icon.webp"}
    alt="Play"
    className="play-button-icon-tm"
  />
  </a>
</div>
        <Container>
          <Row className="align-items-center">
            <Col lg={6}>
              <div className="content-section">
                <h1 className="banner-title">

                  {/* <span className="highlight">{parse(interviewBannerData.interviewHighlight || "")} </span><br />{parse(interviewBannerData.interviewTitle || "")} <br />{parse(interviewBannerData.interviewHighlight || "")} */}

                  <span className="highlight">Exploring New Frontiers </span><br />{parse(interviewBannerData.interviewTitle || "")} <br />H.E. Tumisang Mosotho
                </h1>
                <p className="banner-description-tm">
                  {/* {parse(interviewBannerData.interviewDescription || "")} */}

                  Ambassador Mosotho offered a compelling vision for the country’s role in the digital transformation through Ai, blockchain, and cryptocurrency. He revealed how Lesotho plans to establish itself as a regional hub for sustainable crypto mining. He also discusses the country’s efforts to innovate by tokenizing its rich natural resources. The conversation highlights the nation’s forward-thinking approach to technology and its potential to drive growth and empowerment.
                </p>
              </div>



              <div className="personram-info-desktop">
                <div className="personram-info">
                  <h3 className="personram-name">H.E. Tumisang Mosotho</h3>
                  <p className="personram-title">Ambassador of the Kingdom of Lesotho</p>

                </div>
              </div>





            </Col>

            <Col lg={6}>
              <div className="image-section">
                <div className="personram-card">
                  <div className="personram-image-tm">
                    <img
                      src={imgCDNURL + "Tumisang-Mosotho.webp"}
                      alt="H.E. Tumisang Mosotho"
                      className="img-fluid"
                    />

                    <img
                      src={imgCDNURL + "Pavan-Agarwal.webp"}
                      alt="Pavan Agarwal"
                      className="img-fluid pavanimagechangesdesktop"
                    />
                  </div>
                </div>
              </div>





              {/* <div className="personram-info-mobile">
                <div className="personram-info">
                  <h3 className="personram-name">{parse(interviewBannerData.interviewName || "")}</h3>
                  <p className="personram-title">{parse(interviewBannerData.interviewTitleText || "")}</p>
                  <p className="personram-title-mobile">{parse(interviewBannerData.interviewTitleTextMobile || "")}</p>
                </div>
              </div> */}


              {/* <img
                src={imgCDNURL + "Pavan-Agarwal-mobile.webp"}
                alt="Pavan Agarwal"
                className="img-fluid pavanimagechangesmobile"
              /> */}




              <div className="personpavan-info-desktop">
                <div className="pavannamechanges-info">
                  <h3 className="pavannamechanges-name "><a className="custom-link" href="https://www.swmc.com/pavan" rel='noreferrer noopener' target='_blank'>Pavan Agarwal</a></h3>
                  <p className="pavannamechanges-title custom-link">CEO of <a href="https://www.swmc.com/" rel='noreferrer noopener' target='_blank'>Sun West</a> and Creator of <a href="https://www.swmc.com/angelai" rel='noreferrer noopener' target='_blank'>AngelAi</a></p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>


        
        <div className="speaker-card-mobile-tm">
          <img
            src={imgCDNURL + "Tumisang-Mosotho-mobile.webp"}
            alt="H.E. Tumisang Mosotho"
            className="speaker-image-mobile-tm"
            loading="lazy"
          />
          <div className="speaker-info-strip">
            <h3 className="speaker-name-mobile">H.E. Tumisang Mosotho</h3>
            <p className="speaker-title-mobile">Ambassador of the Kingdom of Lesotho</p>
          </div>
        </div>

        <div className="speaker-card-mobile-tm mt-5">
          <img
            src={imgCDNURL + "Pavan-Agarwal-mobile.webp"}
            alt="Pavan Agarwal"
            className="speaker-image-mobilepavan"
            loading="lazy"
          />
          <div className="speaker-info-strip">
            <h3 className="speaker-name-mobile"><a className="custom-link" href="https://www.swmc.com/pavan" rel='noreferrer noopener' target='_blank'>Pavan Agarwal</a></h3>
            <p className="speaker-title-mobile custom-link">CEO of <a href="https://www.swmc.com/" rel='noreferrer noopener' target='_blank'>Sun West</a> and <br/>Creator of <a href="https://www.swmc.com/angelai" rel='noreferrer noopener' target='_blank'>AngelAi</a></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterviewBanner;
